import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {RelationCabinMock} from './mock'

export const getHomepageData = createAsyncThunk(
  'getHomepageData',
  async (p: any, store: any) => {
    // return RelationCabinMock
    const resp = await http.post(
      '/live/activity/valentine_day_26_relation_cabin',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState: {
  homepage?: {
    rel_id?: string
    unread?: number
    member_1?: {
      name?: string
      mid?: number
      zy_id?: string
      avatar?: string
      age?: number
      gender?: number
    }
    member_2?: {
      name?: string
      mid?: number
      zy_id?: string
      avatar?: string
      age?: number
      gender?: number
    }
    cabin_info?: {
      level?: number
      status?: number
      done?: number
      target?: number
      rewards?: {
        id?: number
        name?: string
        view_icon?: string
        toast_name?: string
        reward_type?: number
        tag?: string
        quantity?: number
        reward_value?: number
        has_show_effect?: boolean
      }[]
    }
    task?: {
      id?: number
      desc?: string
      target?: number
      reward_icon?: string
      reward_name?: string
      reward_num?: number
      cabin_exp?: number
      privilege_id?: number
      has_show_effect?: boolean
      done?: number
      status?: number
    }[]
    new_invites?: number
    new_unbind?: number
  }
} = {
  homepage: {},
}

export const Valentine2026Slice = createSlice({
  name: 'Valentine2026',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepageData.fulfilled, (state, action) => {
      Object.assign(state.homepage, action.payload)
    })
  },
})

export default Valentine2026Slice.reducer
export const Valentine2026Actions = Valentine2026Slice.actions
